module Meevo.Model {
    export class MerchantAccountProvider {
        static isMeevoPay(providerId: number): boolean {
            return providerId === MerchantAccountProviderEnum.Adyen;
        }

        static isMeevoPayCanada(providerId: number): boolean {
            return providerId === MerchantAccountProviderEnum.AdyenCanada;
        }

        static isMeevoPayProvider(providerId: number): boolean {
            return providerId === MerchantAccountProviderEnum.Adyen ||
                   providerId === MerchantAccountProviderEnum.AdyenCanada;
        }
    }
}
